import {UserInterface} from "../Interface/UserInterface";

export const UserModel: UserInterface = {
    id: "",
    username: "",
    email: "",
    avatar: ""
}
